import { render, staticRenderFns } from "./no-data.utils.vue?vue&type=template&id=298ac53e&scoped=true"
import script from "./no-data.utils.vue?vue&type=script&lang=js"
export * from "./no-data.utils.vue?vue&type=script&lang=js"
import style0 from "./no-data.utils.vue?vue&type=style&index=0&id=298ac53e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "298ac53e",
  null
  
)

export default component.exports